/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserPointsResult } from '../../models/get-user-points-result';

export interface GetUserPoints$Params {
  SiteName?: string;
}

export function getUserPoints(
  http: HttpClient,
  rootUrl: string,
  params?: GetUserPoints$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetUserPointsResult>> {
  const rb = new RequestBuilder(rootUrl, getUserPoints.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserPointsResult>;
    }),
  );
}

getUserPoints.PATH = '/Loyalty/user-points';
